module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"提现申请","balanceText":"当前BxC余额","lastSevenDayPrice":"当前JD卡兑换单价","buyBackAccount":"输入回购数量","buyBackTitle":"USDT充值码","addressNotYet":"暂未生成","addressCommited":"已提交，等待生成新的充值码。","showAddress":"查看","dialogTitle":"查看充值码","commitSuccess":"提交回购成功，会在 5 个工作日直接转账至填写的支付宝账号"}}')
  delete Component.options._Ctor
}
